export default "__VITE_ASSET__Da7ZrfK6__"